'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
export const AsyncContactsPriceBreakdownModal = Loadable({
  loader: () => import(
  /* webpackChunkName: "contact-price-breakdown-modal" */
  './ContactsPriceBreakdownModal'),
  LoadingComponent: () => null
});